@if (editMode) {
  <div></div>
}
@if (!editMode) {
  <div>
    @if (!!timelines) {
      <div class="timeline-control">
        <div class="header">
          {{ timeLineHeaderText }}
        </div>
        <div data-timeline>
          @for (line of timelines; track $index) {
            <div
              class="line">
              <div
                class="line-details"
                fxLayout="row"
                fxLayoutAlign="space-between center">
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="category">{{ line.category }}</div>
                  &nbsp;|&nbsp;
                  <div>{{ line.createdName }}</div>
                </div>
                <div>{{ line.createdDate }}</div>
              </div>
              @if (!!line.interview) {
                <div
                  fxLayout="row"
                  fxLayoutAlign="space-between top"
                  class="interview">
                  <div>
                    <div class="title">{{ line.interviewLabels?.date }}</div>
                    <div>{{ line.interview.date ?? ' ' }}</div>
                  </div>
                  <div>
                    <div class="title">{{ line.interviewLabels?.interviwee }}</div>
                    <div>{{ line.interview.interviwee?.name ?? ' ' }}</div>
                    <div class="type">{{ line.interview.interviwee?.type ?? ' ' }}</div>
                  </div>
                  <div>
                    <div class="title">{{ line.interviewLabels?.interviewer }}</div>
                    <div>{{ line.interview.interviewer?.name ?? ' ' }}</div>
                    <div class="type">{{ line.interview.interviewer?.type ?? ' ' }}</div>
                  </div>
                </div>
              }
              <div [innerHTML]="line.description"></div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
